import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Alert,
  Chip,
} from "@mui/material";

import StatusDropDown from "../../../common/components/StatusDropDown";
import { useUpdateStudentQuery } from "../../../api/useUpdateStudent";

const StudentEditDialog = ({ isModalOpen, closeModal, data }) => {
  const { mutate, isError, isPending, error } = useUpdateStudentQuery();
  const [formData, setFormData] = useState(data);
  const [originalData, setOriginalData] = useState({ ...data });
  const [errorMessage, setErrorMessage] = useState("");

  const queryClient = useQueryClient();
  useEffect(() => {
    if (data) {
      setFormData({ ...data });
      setOriginalData({ ...data });
    }
  }, [data]);

  const handleUpdate = () => {
    mutate(formData, {
      onSuccess: () => {
        closeModal(); // 성공 시 모달 닫기
        queryClient.invalidateQueries("students");
      },
      onError: (error) => {
        setErrorMessage(error.response.data.message || "등록에 실패했습니다."); // 실패 시 에러 메시지 설정
      },
    });
  };

  return (
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>유저 정보 수정</DialogTitle>
      {isError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}
      {!formData || !formData.userInfo ? (
        <Alert>데이터 없음</Alert>
      ) : (
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              marginTop: 2,
            }}
          >
            <TextField
              label="이름"
              value={formData.userInfo.name}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  userInfo: { ...formData.userInfo, name: e.target.value },
                })
              }
              fullWidth
            />
            <TextField
              label="이메일"
              value={formData.userInfo.email}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  userInfo: { ...formData.userInfo, email: e.target.value },
                })
              }
              fullWidth
            />
            <TextField
              label="사는 곳"
              value={formData.userInfo.region}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  userInfo: { ...formData.userInfo, region: e.target.value },
                })
              }
              fullWidth
            />
            <StatusDropDown
              selectedStatus={formData.status}
              handleStatusChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
            />
            <TextField
              label="메모"
              value={formData.note}
              onChange={(e) =>
                setFormData({ ...formData, note: e.target.value })
              }
              fullWidth
            />
          </Box>
        </DialogContent>
      )}

      <DialogActions>
        <Button onClick={closeModal} disabled={isPending}>
          취소
        </Button>
        <Button onClick={handleUpdate} disabled={isPending}>
          수정하기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StudentEditDialog;
